import React, { Component } from "react";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSignOutAlt} from "@fortawesome/free-solid-svg-icons";
import {connect} from "react-redux";
import {logoutUser} from "../../actions/authActions";

class Footer extends Component {

    onLogoutClick = e => {
        e.preventDefault();
        this.props.logoutUser();
    };
    render() {
        const { user } = this.props.auth;
        return (            	
         <footer className="footer">
         <div className="container pt-5">
            <div  className="row justify-content-md-center">
               <div  className="col-lg-5 col-md-8">
                  <div  className="row fCompLogo">
                     <div  className="col-4"><a  className="border-0" href="https://3verse.in/#/university"><img  src="/img/cryptoUniversity.svg" className="footeUni_logo1 links"/></a></div>
                     <div  className="col-4 p-md-0 text-center"><a  className="border-0" href="https://3verse.in/#/prices"><img  src="/img/logo.svg" className="footeUni_logo2 links"/></a></div>
                     <div  className="col-4 text-right"><a  className="border-0" href="https://3verse.in/#/cryptotv"><img  src="/img/CryptoTV.svg" className="footeUni_logo links"/></a></div>
                  </div>
               </div>
            </div>
            <div  className="row justify-content-lg-center">
               <div  className="col-lg-6 newsletter text-center py-lg-5 pt-5">
                  <div >
                     <h6 >
                        Stay updated, with our Newsletters.
                        <h4 >Subscribe Now!</h4>
                     </h6>
                     <div  className="newsInput">
                        <input  maxlength="50" phonenochecker="" autocomplete="off" type="text" placeholder="Enter Your email" className="ng-untouched ng-pristine ng-valid"/>
                        <select  className="subscribeAll downArrow ng-untouched ng-pristine ng-valid">
                           <option  className="bgblack" value="15">All</option>
                           <option  className="bgblack" value="1">NewsLetters</option>
                           <option  className="bgblack" value="8">IC15 Daily report</option>
                         
                        </select>
                        <button >Send</button>
                     </div>
                  </div>
                  <div  className="row text-left py-5">
                     <div  className="col-12">
                        <ul  className="fLinks">
                           <li ><b >Markets</b></li>
                           <li ><a  href="https://www.cryptowire.in/#/prices">All Coins</a></li>
                           <li ><a  href="https://www.cryptowire.in/#/prices?type=ranking">Ranking</a></li>
                           <li ><a  href="https://www.cryptowire.in/#/gainers">Gainers</a></li>
                           <li ><a  href="https://www.cryptowire.in/#/losers">Losers</a></li>
                           <li ><a  href="https://www.cryptowire.in/#/market-updates?type=marketHighlights">Highlights</a></li>
                           <li><a  href="https://www.cryptowire.in/#/lending-borrowing">Lending &amp; Borrowing</a></li>
                        </ul>
                     </div>
                     <div  className="col-12 py-3">
                        <ul  className="fLinks">
                           <li ><b >Company</b></li>
                           <li ><a  href="https://cryptowire.in/#/content?type=about">About Us</a></li>
                           <li ><a  href="https://support.cryptowire.in/hc/en-us/requests/new?ticket_form_id=1900000661693" target="_blank">Careers</a></li>
                        </ul>
                     </div>
                     <div  className="col-12">
                        <ul  className="fLinks">
                           <li ><b >Support</b></li>
                           <li ><a  href="https://support.cryptowire.in/hc/en-us/requests/new" target="_blank">Submit a Request</a></li>
                           <li ><a  href="https://support.cryptowire.in/hc/en-us" target="_blank">Contact Support</a></li>
                           <li ><a  href="https://support.cryptowire.in/hc/en-us/categories/4409355517841-FAQs" target="_blank">FAQs</a></li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="container">
            <div className="row text-start justify-content-lg-between">
               <div className="col-md-6">
                  <ul className="fLinks privacy">
                     <li><a href="https://3-verse.io/privacy-policy">Privacy Policy</a></li>
                     <li><a href="https://3-verse.io/terms">Terms of Use</a></li>
                     <li><a href="https://3-verse.io/disclaimer">Disclaimer</a></li>
                     <li><a href="#">Terms and Conditions for Games / Contest </a></li>
                  </ul>
                  <h6 className="copyright">3verse © 2022</h6>
               </div>
               <div  className="col-lg-4 col-md-6 bottomSocial">
                  <i >Follow us on</i>
                  <ul  className="pb-3">
                     <li ><a  target="_blank" className="facebook" href="https://www.facebook.com/100086196572874">Facebook</a></li>
                     <li ><a  target="_blank" className="insta" href="https://www.instagram.com/real3verse">Instagram</a></li>
                     <li ><a  target="_blank" className="twitter" href="https://twitter.com/real3Verse">Twitter</a></li>
                     <li ><a  target="_blank" className="linkedinft" href="https://www.linkedin.com/company/real3verse">Linkedin</a></li>
                     <li ><a  target="_blank" className="redit" href="https://www.reddit.com/user/real3verse">Reddit</a></li>
                     {/* <li ><a  target="_blank" className="pinterest" href="https://www.pinterest.com/realcryptowire/">Pinterest</a></li> */}
                     <li ><a  target="_blank" className="quara" href="https://www.quora.com/profile/Real3Verse">Quora</a></li>
                     <li ><a  target="_blank" className="youtube" href="https://youtube.com/channel/UCAucb7t2m8Y9Mx_DOZU6YKQ">Youtube</a></li>
                  </ul>
               </div>
            </div>
         </div>
      </footer>

        );
    }
}

Footer.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(
    mapStateToProps,
    { logoutUser }
)(Footer);
